import { useTenant } from 'context/TenantContext';

export default function Footer() {
  const tenant = useTenant();

  return (
    <footer className="main-footer">
      <div className="main-footer-inner">
        {/* ⚠️ `|| logoGladiator` RETIRE le 31/08/2026 : l'identite de l'editeur
            n'est jamais un repli. Sans logo de tenant, on n'affiche PAS d'image
            — le pied porte deja la raison sociale en texte juste a cote. */}
        {tenant?.logo_url && <img src={tenant.logo_url} alt="" className="footer-logo" />}
        {tenant?.nom && <span className="footer-text-company">{tenant.nom}</span>}
        {tenant?.rccm && <><span className="footer-sep">&middot;</span><span className="footer-text">RCCM : {tenant.rccm}</span></>}
        {tenant?.nif && <><span className="footer-sep">&middot;</span><span className="footer-text">NIF : {tenant.nif}</span></>}
        {tenant?.cnss && <><span className="footer-sep">&middot;</span><span className="footer-text">CNSS : {tenant.cnss}</span></>}
        {tenant?.ville && <><span className="footer-sep footer-hide-sm">&middot;</span><span className="footer-text footer-hide-sm">{tenant.ville}{tenant.pays ? `, ${tenant.pays}` : ''}</span></>}
        {tenant?.telephone && <><span className="footer-sep">&middot;</span><span className="footer-text">{tenant.telephone}</span></>}
      </div>
    </footer>
  );
}
